import {TextField} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import * as React from "react";


class RenewalMonthsSelector extends React.Component<any, any> {
    public render() {
        const {
            agreement: {
                states: [state],
            },
            durationMonths,
        } = this.props;

        if (durationMonths === null) {
            return null;
        }

        return (
            <TextField
                type="number"
                name="durationMonths"
                label="Renewal of handshake"
                value={durationMonths}
                onChange={this.props.onChangeDurationMonths}
                InputProps={{
                    endAdornment: <InputAdornment position="start">month(s)</InputAdornment>,
                }}
                InputLabelProps={{
                    shrink: true,
                }}
                fullWidth
                disabled={!this.props.configuration[state.id].sendDurationMonths}
            />
        );
    }
}

export default RenewalMonthsSelector;


// WEBPACK FOOTER //
// ./src/modules/shared/dataSharing/RenewalMonthsSelector.tsx